import { render, staticRenderFns } from "./BaseSpeedDial.vue?vue&type=template&id=f0492d1a&scoped=true&"
var script = {}
import style0 from "./BaseSpeedDial.vue?vue&type=style&index=0&id=f0492d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0492d1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VSpeedDial})
